




















import { Component, Prop } from "vue-property-decorator";

import CellRenderer from "../j-conf-cell-renderer.vue"
import { HeaderSetting } from "../types";
import BaseJConfTable from "@share/common/tables/j-conf-table/j-conf-table-base.vue";
import JConfTableHeader from "@share/common/tables/j-conf-table/header/JConfTableHeader.vue";

@Component({ components: { CellRenderer, JConfTableHeader }})

export default class JConfTable extends BaseJConfTable {

    @Prop() items: Record<string, any>[];
    @Prop() headerSettings: HeaderSetting[];
}

